import { render, staticRenderFns } from "./SscAdminInfo.vue?vue&type=template&id=f717f826&"
import script from "./SscAdminInfo.vue?vue&type=script&lang=js&"
export * from "./SscAdminInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports